import React, {useEffect, useState} from "react";
import {Filter} from "../Filter";

export default function FunctionalAreaFilter({statusData, filteredData, expanded, onExpandClick, onStatusUpdate, name}) {
    const [statusList, setStatusList] = useState([]);
    const handleChange = (event) => {
        const updatedList = statusList.map(list => {
            if (list.name === event.target.name) {
                list.checked = event.target.checked
            }
            return list
        })
        onStatusUpdate(updatedList)
        setStatusList(updatedList)
        sessionStorage.setItem("selectedFunctionalAreas", JSON.stringify(updatedList));
    };

    useEffect(() => {
        const list = statusData.map(item => {
            return filteredData.includes(item) ? {
                name: item,
                label: item,
                checked: true
            } : {name: item, label: item, checked: false}
        })

        setStatusList(list)
    }, [statusData, filteredData]);

    return (
        <Filter expanded={expanded} onChange={onExpandClick} statusList={statusList}
                onFilterUpdate={handleChange} name={name}/>
    );
}
